import { AEMModelAssets } from './constants';

export function createLocalStorageObjectToSave(tiles, buildCtaType, currentBuildUrl) {
  const ctaText = buildCtaType === 'new-build' ? 'new-build' : 'resume-build';
  const contentTilesFrontEndFormat = {};

  tiles.forEach((modelName, index) => {
    const name = AEMModelAssets[modelName];
    if (name) {
      const template = `Audi ${AEMModelAssets[modelName]}`;
      if (index === 0) {
        contentTilesFrontEndFormat[template] = {
          type: ctaText,
          url: buildCtaType === 'resume-build' ? currentBuildUrl : null,
          modelName,
        };
      } else {
        contentTilesFrontEndFormat[template] = { type: 'mlp', modelName };
      }
    }
  });

  return contentTilesFrontEndFormat;
}
